<template>
  <div class="PersonalProfile">
    <SpForm ref="form" class="form" @submit="submit">
      <div class="flex-jc-bt">
        <div class="flex-60">
          <sp-tag-group v-model="type" class="tags">
            <sp-tag label="Contacts">
              {{ $l('Contacts') }}
            </sp-tag>
            <sp-tag label="Experience">
              {{ $l('Experience') }}
            </sp-tag>
            <sp-tag label="NewOffer">
              {{ $l('New Offer') }}
            </sp-tag>
          </sp-tag-group>
        </div>
        <div class="flex-40">
          <div v-show="type=== 'Contacts'" class="flex-jc-end">
            <SpButton type="back" :width="240" :height="70" :circle-radius="4" :bold="-1" class="mg-r-20">
              <span class="font-bold font18 sp-color-11">Back</span>
            </SpButton>
            <SpButton type="primary" html-type="submit" :width="280" :height="70" :circle-radius="4" :bold="-1">
              <span class="font-bold font18 sp-color-4">Submit</span>
            </SpButton>
          </div>
          <div v-show="type !== 'Contacts'" class="flex-jc-end">
            <SpButton type="back" :width="240" :height="70" :circle-radius="4" :bold="-1" class="mg-r-20">
              <span class="font-bold font18 sp-color-11">Back</span>
            </SpButton>
            <SpButton type="primary" :width="280" :height="70" :circle-radius="4" :bold="-1" @click="logOut">
              <span class="font-bold font18 sp-color-4">Go To Log In (Work Platform)</span>
            </SpButton>
          </div>
        </div>
      </div>
      <Contract v-if="type==='Contacts'" v-model="individualInfo" />
    </SpForm>
    <Experience v-if="type==='Experience'" />
    <NewOffer v-if="type==='NewOffer'" />
  </div>
</template>

<script type="text/ecmascript-6">
import spTag from '@/components/common/SpTag'
import spTagGroup from '@/components/common/SpTagGroup'
import { modifyIndividualInfo } from '@/request/APIs/natural'
import { computed, reactive, ref } from '@vue/reactivity'
import SpForm from '@/components/common/SpForm.vue'
import Contract from './Contract.vue'
import Experience from './Experience.vue'
import { useStore } from 'vuex'
import SpMessage from '@/components/common/SpMessage'
import { onMounted } from 'vue'
import { nextTick } from '@vue/runtime-core'
import { useRoute, useRouter } from 'vue-router'
import logAndSign, { getUserInfo } from '@/request/APIs/logAndSign'
import store from '@/store'
import NewOffer from '@/components/natural/personalProfile/NewOffer'
import SpButton from '@/components/common/SpButton'
export default {
  name: 'PersonalProfile',

  nameSpace: 'natural.PersonalProfile',

  components: {
    SpButton,
    NewOffer,
    spTag,
    spTagGroup,
    SpForm,
    Contract,
    Experience
  },

  inject: ['reload'],

  props: {
  },

  setup () {
    const store = useStore()
    const individualInfo = computed({
      get () {
        const info = store.state.user.user
        if (Object.prototype.toString.call(info?.emails) === '[object Array]') {
          info.emails = info?.emails ? info?.emails?.join(';') : ''
        }

        return store.state.user.user
      },
      set (nv) {
        store.dispatch('user/setUser', nv)
      }
    })
    const form = ref(null)
    const updateValue = () => {
      nextTick(() => {
        form.value.setFormItemValue({ ...store.state.user.user, emails: store.state.user.user.emails?.join(';') })
      })
    }
    const type = ref('Contacts')
    const router = useRouter()
    const route = useRoute()
    const submit = (formData) => {
      if (formData.validate) {
        const data = formData.data
        data.individualCodeName = data.codeName
        data.mobileCode = individualInfo.value.phonecode
        if (Object.prototype.toString.call(data.emails) === '[object Array]') {

        }
        delete data.codeName
        modifyIndividualInfo(data).then(res => {
          if (res.code === 1) {
            SpMessage.success('success!')
            individualInfo.value.serialNo = res.data.serialNo
            if (route.query?.back) {
              getUserInfo().then(res => {
                if (res?.code === 1) {
                  const data = res.data
                  if (data) {
                    data.avatar = Object.values(data.avatar || {})[0] || ''
                    data.qq = data.qq === 0 ? '' : data.qq
                    store.dispatch('user/setUser', { userId: data.id, userName: data.name, userType: data.identity, isLogin: true, ...data })
                    router.back()
                  }
                }
              })
            }
          }
          // else {
          //   SpMessage.error(res.data.join(','))
          // }
        })
      } else {
        SpMessage.error('Check the form list please!')
      }
    }
    const logOut = () => {
      logAndSign.logOut().then(res => {
        window.location.href = 'index.html#/'
      })
    }
    return {
      form,
      type,
      individualInfo,
      submit,
      updateValue,
      logOut
    }
  }
}
</script>

<style scoped lang="less">
.PersonalProfile{
  padding:@gap*2;
  .form{
      margin:0 0 @gap 0;
      // >*{
      //   margin-right: 5px;
      // }
    }
}
</style>
